import React from "react";
import { motion } from "framer-motion";
import SectionHeading from "./SectionHeading";
import ProgramOption from "./ProgramOption";

const EnglishTuitionSection: React.FC = () => {
  return (
    <section className="flex flex-col justify-center items-center px-20 pt-48 pb-16 bg-black max-md:px-5">
      <div className="absolute top-0 left-0 w-full h-40 bg-white"></div>

      <div className="flex flex-col max-w-full w-[1266px]">
        <SectionHeading
          title="Unlock Your Potential with
Our English"
          subtitle="Tuition Programs"
          description="At iExcel International English, we provide a range of English
tuition programs tailored for students aged 5 to 18. Our
curriculum is designed to enhance reading, writing, speaking,
and comprehension skills, ensuring academic success and
confident communication."
        />

        <div className="self-end mt-9 mr-7 max-w-full w-[588px] max-md:mr-2.5">
          <div className="flex gap-5 max-md:flex-col">
            <div className="w-6/12 max-md:ml-0 max-md:w-full">
              <ProgramOption
                title="Online"
                description="Flexible learning from home, tailored to fit
your schedule and learning style."
              />
            </div>
            <div className="ml-5 w-6/12 max-md:ml-0 max-md:w-full">
              <ProgramOption
                title="In-Person"
                description="Immersive classroom experience with
direct interaction and collaborative
activities."
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EnglishTuitionSection;
